"use strict";

exports.__esModule = true;
exports.ReportListAccordianWrapper = ReportListAccordianWrapper;
var _react = _interopRequireWildcard(require("react"));
var _Accordian = require("../../Core/Accordian");
var _constants = require("../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ReportListAccordianWrapper(props) {
  var items = props.items,
    renderItem = props.renderItem,
    renderItemContent = props.renderItemContent,
    getKey = props.getKey,
    itemWidth = props.itemWidth,
    expandedViewHeight = props.expandedViewHeight,
    expandedViewMaxHeight = props.expandedViewMaxHeight;
  var _useState = (0, _react.useState)([_constants.TAG_UNTAGGED]),
    openItems = _useState[0],
    setOpenItems = _useState[1];
  function isItemOpen(item) {
    return openItems.includes(item);
  }
  function toggleItemOpen(item) {
    if (isItemOpen(item)) {
      setOpenItems(openItems.filter(function (itemName) {
        return itemName !== item;
      }));
    } else {
      setOpenItems([].concat(openItems, [item]));
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_Accordian.Accordian, {
    toggleItemOpen: toggleItemOpen,
    isItemOpen: isItemOpen,
    items: items,
    renderItem: renderItem,
    renderItemContent: renderItemContent,
    getKey: getKey,
    itemWidth: itemWidth,
    expandedViewHeight: expandedViewHeight,
    expandedViewMaxHeight: expandedViewMaxHeight
  });
}